import React, { useEffect, useState } from 'react';
import { getPermissionById, isEmpty } from '@/utils';
import { CLSTAG, PermissionButton } from '@/utils/constant';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/index';
import CallFrontlinerModal from '@/components/CallFrontlinerModal';
import { clstagStr } from '@/utils/util';

const CallFrontliner = (props: { vehicleName: string; disabled?: boolean }) => {
  const { vehicleName, disabled } = props;
  const login = useSelector((state: RootState) => state.login);
  const [open, setOpen] = useState(false);
  const [callFrontPermission, setCallFrontPermission] = useState(true);
  useEffect(() => {
    if (!isEmpty(login.resourceList)) {
      setCallFrontPermission(
        getPermissionById(PermissionButton.SPV_CALL_FRONT),
      );
    }
  }, [login]);

  return (
    <>
      <div
        className={classNames('', {
          'mini-item': !disabled,
          'mini-item-disabled': disabled,
        })}
        onClick={() => {
          if (!callFrontPermission || disabled) {
            return;
          }
          setOpen(true);
        }}
        clstag={clstagStr(CLSTAG.CallFrontliner)}
      >
        <div
          className={classNames('', {
            'operate-callFront': callFrontPermission && !disabled,
            'operate-callFront-disabled': !callFrontPermission || disabled,
          })}
        />

        <h3 className='operate_key'>呼叫一线</h3>
      </div>
      <CallFrontlinerModal
        vehicleName={vehicleName}
        open={open}
        setOpen={setOpen}
      />
    </>
  );
};
export default React.memo(CallFrontliner);
